import { render, staticRenderFns } from "./CalendarDateIndicator.vue?vue&type=template&id=13bd4725&scoped=true"
import script from "./CalendarDateIndicator.vue?vue&type=script&lang=js"
export * from "./CalendarDateIndicator.vue?vue&type=script&lang=js"
import style0 from "./CalendarDateIndicator.vue?vue&type=style&index=0&id=13bd4725&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13bd4725",
  null
  
)

export default component.exports